import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-screen" }
const _hoisted_2 = { class: "main-screen__top" }
const _hoisted_3 = { class: "main-screen__top-wrap" }

import GreenButton from "@/components/uikit/GreenButton.vue";
import IntroButton from "./uikit/IntroButton.vue";
import { useGameStore } from "@/stores/index";
import router from "@/router";
import Cookies from "js-cookie";
import { uuidv7 } from "uuidv7";
import { onMounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainScreen',
  setup(__props) {

const store = useGameStore();
const userId = Cookies.get("user_id");
const mainBg = ref(false);
const skipButton = ref(true);

// Начало квиза
const startGame = async () => {
  if (!userId) {
    const newUserId = uuidv7();
    Cookies.set("user_id", newUserId, { expires: 7 });
  }

  await store.startGame();

  router.push(store.gameStage ?? "/quiz");
};

// Повтор интро
const playIntro = () => {
  const video = document.getElementById("myVideo") as HTMLVideoElement;
  mainBg.value = false;
  skipButton.value = true;
  if (video) {
    video.currentTime = 0;
    video.play();
    video.addEventListener("ended", () => {
      mainBg.value = true;
      skipButton.value = false;
    });
  }
};

// Пропуск интро
const skipIntro = () => {
  mainBg.value = true;
  skipButton.value = false;
  const video = document.getElementById("myVideo") as HTMLVideoElement;
  if (video) {
    video.pause();
  }
};

onMounted(() => {
  playIntro();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-screen__video", { 'main-screen__bg--active': !mainBg.value }])
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("video", {
        id: "myVideo",
        src: "/videos/intro.mp4",
        autoplay: "",
        muted: "",
        playsinline: ""
      }, null, -1)
    ]), 2),
    _createElementVNode("div", {
      class: _normalizeClass(["main-screen__bg", { 'main-screen__bg--active': mainBg.value }])
    }, null, 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "main-screen__logo",
        to: "/"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            src: "/images/main-screen-logo.svg",
            alt: ""
          }, null, -1)
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (skipButton.value)
          ? (_openBlock(), _createBlock(IntroButton, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (skipIntro()))
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("пропустить интро ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(IntroButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (playIntro()))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("смотреть интро "),
            _createElementVNode("img", {
              src: "/images/repeat-icon.svg",
              alt: ""
            }, null, -1)
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["main-screen__content", { 'main-screen__content--active': mainBg.value }])
    }, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "h1" }, "система готова к синхронизации", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "main-screen__text" }, " Погрузись в различные миссии, прими важное решение и узнай, насколько ты един с ценностями МИФИ ", -1)),
      _createVNode(GreenButton, { onClick: startGame }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("приступить")
        ])),
        _: 1
      }),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "main-screen__time font-tektur" }, "около 6 минут", -1))
    ], 2)
  ]))
}
}

})